/**
 * Lightweight diagnostics registry so deep, page-local React state (which a Layout-level
 * dialog can't reach via props/context) can be attached to feedback reports.
 *
 * A page registers a snapshot provider, usually a function that reads a ref kept updated each
 * render, so it always returns the latest state. The feedback dialog calls collectDiagnostics()
 * at capture time. Providers are keyed; registering returns an unregister function.
 */
const providers = new Map();

export const registerDiagnostics = (key, provider) => {
  providers.set(key, provider);
  return () => {
    if (providers.get(key) === provider) {
      providers.delete(key);
    }
  };
};

export const collectDiagnostics = () => {
  const out = {};
  providers.forEach((provider, key) => {
    try {
      out[key] = provider();
    } catch (e) {
      out[key] = { error: String(e && e.message ? e.message : e) };
    }
  });
  return out;
};

export default { registerDiagnostics, collectDiagnostics };
